import React, { useEffect } from 'react';

const APP_NAME = 'PowerZap by Kory - WhatsApp for Bitrix24';

export function TermsPage() {
	useEffect(() => {
		document.title = `Terms Of Use - ${APP_NAME}`;
		return () => {
			document.title = `${APP_NAME}`;
		};
	}, []);

	return (
		<div style={{ maxWidth: 900, margin: '0 auto', padding: '40px 24px' }}>
			<h1>End-User License Agreement (EULA) of {APP_NAME}</h1>

			<p>This End-User License Agreement ("EULA") is a legal agreement between you and Kory.</p>
			<p>
				This EULA agreement governs your acquisition and use of our {APP_NAME} software ("Software")
				directly from Kory or indirectly through a Kory authorized reseller or distributor (a
				"Reseller").
			</p>
			<p>
				Please read this EULA agreement carefully before completing the installation process and
				using the {APP_NAME} software. It provides a license to use the {APP_NAME} software and
				contains warranty information and liability disclaimers.
			</p>
			<p>
				If you register for a free trial of the {APP_NAME} software, this EULA agreement will also
				govern that trial. By installing and/or using the {APP_NAME} software, you are confirming
				your acceptance of the Software and agreeing to become bound by the terms of this EULA
				agreement.
			</p>
			<p>
				If you are entering into this EULA agreement on behalf of a company or other legal entity,
				you represent that you have the authority to bind such entity and its affiliates to these
				terms and conditions. If you do not have such authority or if you do not agree with the
				terms and conditions of this EULA agreement, do not install or use the Software, and you
				must not accept this EULA agreement.
			</p>
			<p>
				This EULA agreement shall apply only to the Software supplied by Kory herewith regardless of
				whether other software is referred to or described herein. The terms also apply to any Kory
				updates, supplements, Internet-based services, and support services for the Software, unless
				other terms accompany those items on delivery. If so, those terms apply.
			</p>

			<h2>License Grant</h2>
			<p>
				Kory hereby grants you a non-transferable, non-exclusive licence to use the {APP_NAME} on
				your Bitrix24 in accordance with the terms of this EULA agreement.
			</p>
			<p>
				You are permitted to install the {APP_NAME} software under your control. You are responsible
				for ensuring your Bitrix24, internet browser and necessary software meet the minimum
				requirements of the {APP_NAME} software.
			</p>
			<p>You are not permitted to:</p>
			<ul>
				<li>
					Edit, alter, modify, adapt, translate or otherwise change the whole or any part of the
					Software nor permit the whole or any part of the Software to be combined with or become
					incorporated in any other software, nor decompile, disassemble or reverse engineer the
					Software or attempt to do any such things
				</li>
				<li>
					Reproduce, copy, distribute, resell or otherwise use the Software for any commercial
					purpose
				</li>
				<li>
					Allow any third party to use the Software on behalf of or for the benefit of any third
					party
				</li>
				<li>
					Use the Software in any way which breaches any applicable local, national or international
					law
				</li>
				<li>
					Use the Software for any purpose that Kory considers is a breach of this EULA agreement
				</li>
			</ul>

			<h2>Intellectual Property and Ownership</h2>
			<p>
				Kory shall at all times retain ownership of the Software as originally downloaded
				(installed) by you and all subsequent downloads (installations) of the Software by you. The
				Software (and the copyright, and other intellectual property rights of whatever nature in
				the Software, including any modifications made thereto) are and shall remain the property of
				Kory.
			</p>
			<p>Kory reserves the right to grant licences to use the Software to third parties.</p>

			<h2>Termination</h2>
			<p>
				This EULA agreement is effective from the date you first use the Software and shall continue
				until terminated. You may terminate it at any time upon written notice to Kory.
			</p>
			<p>
				It will also terminate immediately if you fail to comply with any term of this EULA
				agreement. Upon such termination, the licenses granted by this EULA agreement will
				immediately terminate and you agree to stop all access and use of the Software. The
				provisions that by their nature continue and survive will survive any termination of this
				EULA agreement.
			</p>

			<h2>Governing Law</h2>
			<p>
				This EULA agreement, and any dispute arising out of or in connection with this EULA
				agreement, shall be governed by and construed in accordance with the laws of Brazil.
			</p>
		</div>
	);
}
